var map = {
	"./bear-slice.png": 7263,
	"./t-2-q-10-1.png": 3317,
	"./t-2-q-10-2.png": 6590,
	"./t-2-q-10-3.png": 8727,
	"./t-2-q-10-4.png": 9112,
	"./t-2-q-9-1.png": 805,
	"./t-2-q-9-2.png": 2030,
	"./t-2-q-9-3.png": 2023,
	"./t-2-q-9-4.png": 2408
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1483;